import React, { useState, useRef, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import _get from 'lodash/get';
import api from '../api/api';

export const DialogAcessoAlunos = ({
  visible,
  setVisible,
  nota,
  falta,
  matVigente,
  cpf,
  perfil,
}) => {
  const fileUploadRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [uploadMessage, setUploadMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [arquivosAluno, setArquivosAluno] = useState([]);

  const anoAtual = new Date().getFullYear();

  const nomeAluno = _get(perfil.data, 'nome', 'Não foi possível obter o nome do aluno');

  // --- LÓGICA DE FILTRAGEM ---
  const notasAtuais = nota.filter((item) => item.matricula.turma.ano === anoAtual);
  const notasHistorico = nota.filter((item) => item.matricula.turma.ano !== anoAtual);

  const faltasAtuais = falta.filter((item) => {
    const anoFalta = new Date(item.dataOcorrencia).getFullYear();
    return anoFalta === anoAtual;
  });
  const faltasHistorico = falta.filter((item) => {
    const anoFalta = new Date(item.dataOcorrencia).getFullYear();
    return anoFalta !== anoAtual;
  });

  // --- FUNÇÕES DE RENDERIZAÇÃO ---
  const renderTabelaNotas = (dados) => (
    <table width="100%" border="1" style={{ borderCollapse: 'collapse', marginTop: '10px' }} cellPadding={3}>
      <thead>
        <tr style={{ backgroundColor: '#f4f4f4' }}>
          <th>Código</th>
          <th>Ano</th>          
          <th>Instrutor</th>
          <th>Curso</th>
          <th>Notal Total</th>
          <th>Nota Aluno</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        {dados.map((item) => (
          <tr key={item.id}>
            <td align="center">{item.id}</td>
            <td align="center">{item.matricula.turma.ano}</td>            
            <td>{item.matricula.turma.perfil.nome}</td>
            <td>{item.matricula.turma.curso.nome}</td>
            <td align="center">{item.avaliacao.notaTotal}</td>
            <td align="center"><b>{item.notaAluno}</b></td>
            <td>{item.avaliacao.nomeTipoExibicao}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderTabelaFaltas = (dados) => (
    <table width="100%" border="1" style={{ borderCollapse: 'collapse', marginTop: '10px' }} cellPadding={3}>
      <thead>
        <tr style={{ backgroundColor: '#f4f4f4' }}>
          <th>Código</th>
          <th>Ocorrência</th>
          <th>Observação</th>
          <th>Data</th>
        </tr>
      </thead>
      <tbody>
        {dados.map((item) => (
          <tr key={item.id} style={{ textTransform: 'uppercase' }}>
            <td align="center">{item.id}</td>
            <td align="center">{item.atraso ? "ATRASO" : "FALTA"}</td>
            <td>{item.obs}</td>
            <td align="center">{new Date(item.dataOcorrencia + ' 03:00:00.000').toLocaleDateString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  // --- EFEITOS E CHAMADAS API ---
  useEffect(() => {
    if (cpf && visible) listarArquivos();
  }, [cpf, visible]);

  const listarArquivos = async () => {
    try {
      const response = await api.get(`/matricula/arquivos/${cpf}`);
      setArquivosAluno(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setArquivosAluno([]);
    }
  };

  const baixarArquivo = async (arquivo) => {
    try {
      const response = await api.get(`/matricula/download/${arquivo}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', arquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) { alert('Erro ao baixar arquivo.'); }
  };

  const uploadHandler = async (e) => {
    const file = e.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('doc', file);
      formData.append('cpf', cpf);
      formData.append('nomeAluno', nomeAluno);
      await api.post('/matricula/uploadDoc', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setUploadMessage('Sucesso!');
      listarArquivos();
      fileUploadRef.current.clear();
    } catch (error) { setUploadMessage('Erro no envio.'); }
    finally { setLoading(false); setTimeout(() => setUploadMessage(''), 3000); }
  };

  return (
    <Dialog
      header={`Área do Aluno: ${nomeAluno}`}
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: '70vw' }}
      breakpoints={{ '960px': '85vw', '640px': '100vw' }}
    >
      <div className="p-mb-4">
        {matVigente.map((item, idx) => (
          <p key={idx} style={{ fontSize: '0.9rem', borderLeft: '4px solid #2196F3', paddingLeft: '10px' }}>
            <b>Vigente:</b> {item.turma.diaSemana} às {item.turma.hora} | {item.turma.curso.sigla} | 
            Instrutor: {item.turma.perfil.nome} | <span style={{color: 'green'}}>{item.status}</span>
          </p>
        ))}
      </div>

      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        
        <TabPanel header="Avaliações">
          <h4>Ano Atual ({anoAtual})</h4>
          {notasAtuais.length > 0 ? renderTabelaNotas(notasAtuais) : <p>Nenhuma nota registrada em {anoAtual}.</p>}

          {notasHistorico.length > 0 && (
            <Accordion className="p-mt-4">
              <AccordionTab header="Ver Histórico de Anos Anteriores">
                {renderTabelaNotas(notasHistorico)}
              </AccordionTab>
            </Accordion>
          )}
        </TabPanel>

        <TabPanel header="Faltas/Atrasos">
          <h4>Ocorrências de {anoAtual}</h4>
          {faltasAtuais.length > 0 ? renderTabelaFaltas(faltasAtuais) : <p>Nenhuma falta ou atraso em {anoAtual}.</p>}

          {faltasHistorico.length > 0 && (
            <Accordion className="p-mt-4">
              <AccordionTab header="Ver Histórico de Faltas Antigas">
                {renderTabelaFaltas(faltasHistorico)}
              </AccordionTab>
            </Accordion>
          )}
        </TabPanel>

        <TabPanel header="Documentos">
          <div className="p-grid p-dir-col p-ai-center">
            <FileUpload 
              ref={fileUploadRef} mode="advanced" customUpload uploadHandler={uploadHandler}
              chooseLabel="Selecionar Documento" uploadLabel="Enviar" cancelLabel="Limpar"
              maxFileSize={10000000} disabled={loading}
            />
            {uploadMessage && <p style={{ color: 'blue' }}>{uploadMessage}</p>}
            
            <div style={{ width: '100%', marginTop: '2rem' }}>
              <h5>Arquivos em Prontuário</h5>
              {arquivosAluno.length > 0 ? (
                arquivosAluno.map((arq, i) => (
                  <Button key={i} label={arq} icon="pi pi-file-pdf" className="p-button-text p-button-sm" onClick={() => baixarArquivo(arq)} />
                ))
              ) : <p>Nenhum documento.</p>}
            </div>
          </div>
        </TabPanel>
      </TabView>
    </Dialog>
  );
};